import CardWrapper from '../card-wrapper';
import Step03Image from '../../../../../assets/images/memory/onboarding/step-03-01.svg';
import StepButton from '../step-button';
import { Icon } from '../../../../../core/components/atoms/Icon';
import { Typography } from '../../../../../core/components/molecules/Typography';

const Step03B = ({
  onNextStep,
  onPreviousStep,
}: {
  onNextStep: () => void;
  onPreviousStep: () => void;
}) => {
  return (
    <CardWrapper.Root side='left'>
      <CardWrapper.Primary className='flex flex-col items-center justify-center gap-4 px-5'>
        <div className='flex flex-col items-start gap-4'>
          <Typography
            title='h1'
            className='!text-h1 font-bold text-mono-color-darker'
          >
            <i>Flashcards</i>
          </Typography>
          <Typography
            title='h3'
            className='!text-h3 font-bold text-mono-color-darker'
          >
            Criando um <i>flashcard</i>
          </Typography>
          <div className='flex flex-col gap-4'>
            <Typography
              title='h1'
              className='!text-md !font-normal text-mono-color-darker'
            >
              Em Criar <i>Flashcards</i>. Adicione os Decks que deseja adicionar
              o {' '}<i>Flashcard</i>.{' '}
              <span className='font-bold text-mono-color-dark'>
                (Não é obrigatório, mas para que o <i>flashcard</i> entre no
                processo de Revisão, será necessário adiciona-lo ao Deck
                futuramente).
              </span>
            </Typography>
            <Typography
              title='h1'
              className='!text-md !font-normal text-mono-color-darker'
            >
              Em seguida, Adicione a frente e o verso do cartão.
            </Typography>
            <Typography
              title='h1'
              className='!text-md !font-normal text-mono-color-darker'
            >
              Para finalizar, adicione uma tag para facilitar a busca do
              {' '}<i>flashcard</i>.
            </Typography>
            <Typography
              title='h1'
              className='!text-md !font-bold text-mono-color-dark'
            >
              Seu <i>Flashcard</i> foi criado com sucesso!
            </Typography>
          </div>
        </div>
        <div className='flex w-full justify-end'>
          <StepButton label='Voltar' onClick={onPreviousStep} type='text' />
          <StepButton
            label='Continuar'
            onClick={onNextStep}
            icon={<Icon Icon={'keyboard_arrow_right'} type='material' />}
          />
        </div>
      </CardWrapper.Primary>

      <CardWrapper.Secondary className='h-[679px] w-[476px] rounded-lg '>
        <img
          src={Step03Image}
          alt='Step 03-B'
          className='h-full w-full rounded-lg md:object-none'
        />
      </CardWrapper.Secondary>
    </CardWrapper.Root>
  );
};

export default Step03B;
